import { FormattedNotificationItemType, INotificationFormatter } from '@/lib/formatter/notification-formatter'
import { NotificationType } from '@/types/notification'

/**
 * JOB_APPLICATIONS notification formatter
 * Extends notification with a link to the job application detail page.
 * Payload is expected to carry at least { id, firstname, lastname, position }.
 */
export default class JobApplicationsFormatter implements INotificationFormatter {
  format(notification: NotificationType): FormattedNotificationItemType {
    const payload = notification.payload
    const id = payload?.id

    const additionalParams: Array<{
      key: string
      values?: Record<string, any>
    }> = []

    if (payload?.firstname || payload?.lastname) {
      const name = [payload?.firstname, payload?.lastname].filter(Boolean).join(' ')
      additionalParams.push({ key: 'applicant', values: { name } })
    }

    if (payload?.position) {
      additionalParams.push({ key: 'position', values: { position: payload.position } })
    }

    return {
      ...notification,
      additionalParams,
      link: id ? `/user-interactions/job-applications/${id}` : undefined
    }
  }
}
